import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import './InviteOnlyPage.css';

const InviteOnlyPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="invite-only-page">
      <div className="invite-only-container">
        <div className="invite-only-header">
          <div className="invite-only-header-spacer" />
          <br />
          <br />
          <br />

          {/* <div className="invite-only-icon-wrapper"> */}
            {/* <Mail className="invite-only-icon" aria-hidden /> */}
          {/* </div> */}
          <h1 className="invite-only-title">Invite only</h1>          

          <p className="invite-only-content">
            The platform is currently invite-only while we onboard early teams. <br />If you are interested in accessing the platform, please contact us at hi@novembr.dev.

          </p>
        </div>

        <div className="invite-only-content">
          <button type="button" className="invite-only-back" onClick={() => navigate('/')}>
            Back to home
          </button>
        </div>
      </div>
    </section>
  );
};

export default InviteOnlyPage;
